/* global Turbo */
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  reset () {
    setTimeout(() => {
      Turbo.visit(window.location.href, { action: 'replace' })
    }, 1000)
  }

  clearInput () {
    this.element.reset()
  }
}
